import React from 'react';
import { Input, Button, UncontrolledTooltip, Card, CardBody, CardHeader } from 'reactstrap';

const ItemCard = ({
  index,
  isFirst,
  isLast,
  clickSort,
  answer,
  className,
  showConfirmation,
  removeItem,
  error,
  onChangeAnswer,
  questionRoutesLoading,
  questionRoutes,
  disabled
}) => {
  return (
    <Card className={className}>
      {!disabled && (
        <CardHeader>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex">
              <Button
                size="sm"
                color="primary"
                onClick={() => {
                  clickSort(index, index > 0 ? index - 1 : 0);
                }}
                disabled={isFirst}>
                <i className="fas fa-angle-up" />
              </Button>

              <Button
                size="sm"
                color="primary"
                className="ml-0"
                onClick={() => {
                  clickSort(index, index + 1);
                }}
                disabled={isLast}>
                <i className="fas fa-angle-down" />
              </Button>
            </div>
            <button
              type="button"
              className="table-action table-action-delete"
              id={`tooltip-delete-${answer.id}`}
              onClick={(e) => {
                e.preventDefault();
                showConfirmation({
                  title: 'Are you sure want to delete?',
                  confirmTitle: 'Delete',
                  onConfirm: () => {
                    removeItem(index);
                  }
                });
              }}>
              <i className="fas fa-trash" />
            </button>
            <UncontrolledTooltip delay={0} target={`tooltip-delete-${answer.id}`}>
              Delete Answer
            </UncontrolledTooltip>
          </div>
        </CardHeader>
      )}
      <CardBody>
        <Input
          value={answer.answer}
          invalid={error && !answer.answer}
          disabled={disabled}
          onChange={(e) => {
            onChangeAnswer(index, 'answer', e.target.value);
          }}
          placeholder="Answer"
          className="mb-2"
        />

        <Input
          value={answer.email}
          disabled={disabled}
          onChange={(e) => {
            onChangeAnswer(index, 'email', e.target.value);
          }}
          placeholder="Email Alert"
          className="mb-2"
        />

        <div>
          {questionRoutesLoading && (
            <div>
              <small>Loading...</small>
            </div>
          )}
          {!questionRoutesLoading && (
            <Input
              type="select"
              value={answer.route || ''}
              disabled={disabled}
              onChange={(e) => {
                onChangeAnswer(index, 'route', e.target.value);
              }}>
              <option value="">Next</option>
              {questionRoutes.map((question) => (
                <option value={question.id} key={question.id}>
                  {question.sortOrder} - {question.question}
                </option>
              ))}
            </Input>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default ItemCard;
